(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[464],{

/***/ 58262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/components/product/relevance/wrapper/index.module.scss
var index_module = __webpack_require__(89262);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/tdk/index.tsx + 1 modules
var tdk = __webpack_require__(6071);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/product/relevance/nav/index.module.scss
var nav_index_module = __webpack_require__(73649);
var nav_index_module_default = /*#__PURE__*/__webpack_require__.n(nav_index_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/product/relevance/nav/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */








var timer;

var Nav = function Nav(_ref) {
  var defaultIndex = _ref.defaultIndex,
      menu = _ref.menu,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 1 : _ref$type;

  var _useState = (0,react.useState)(defaultIndex || 0),
      current = _useState[0],
      setCurrent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      once = _useState3[0],
      setOnce = _useState3[1]; //首次动画执行


  var count = (0,react.useRef)(0); // 首次动画执行占位不需要过渡效果 0初始状态 1 首次动画执行（自动滚动），其余为手动滚动

  var dom = (0,react.useRef)(null);
  var subNav = (0,react.useRef)();
  var menuRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var onScroll = (0,react.useCallback)(function () {
    var scrollTop = document.documentElement.scrollTop;

    if (scrollTop > 100) {
      count.current++;
      setSticky(true);
      setOnce(false);
      count.current++;
    } else {
      if (count.current >= 1) {
        count.current = 2;
      }

      setSticky(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
  (0,react.useEffect)(function () {
    if (window.innerWidth > 768) {
      setOnce(true);
      requestAnimation();
    }
  }, []);

  var requestAnimation = function requestAnimation() {
    var scrollTop = document.documentElement.scrollTop;
    var speed = scrollTop > 80 ? 1 : 2;
    timer = window.requestAnimationFrame(function () {
      if (scrollTop > 100) {
        cancelAnimationFrame(timer);
      } else {
        document.documentElement.scrollTop = scrollTop + speed;
        requestAnimation();
      }
    });
  }; // 移动端-设置当前页面导航按钮是否在可视口完全显示


  (0,react.useEffect)(function () {
    var _menuRef$current;

    var childNodes = (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.childNodes;

    if (childNodes && window.innerWidth < 768) {
      var child = childNodes[current];
      var position = child.getClientRects();
      var _position$ = position[0],
          left = _position$.left,
          width = _position$.width;
      var diff = left + width - window.innerWidth;

      if (diff > 0) {
        if (menuRef.current) {
          var distance = menuRef.current.scrollLeft + diff + 10;
          menuRef.current.scrollLeft = distance;
        }
      }
    }
  }, []);

  var Goto = function Goto(index, url) {
    setCurrent(index);
    router.push(url); // window.location.href = url;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: dom,
      className: classnames_default()((nav_index_module_default()).nav__theme_parent, once && (nav_index_module_default()).once, sticky && (nav_index_module_default()).sticky),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default()).logo, sticky && (nav_index_module_default()).show, !sticky && (nav_index_module_default()).hide),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: constants/* homeUrl */.hB,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/v2/images/login-logo.png",
            alt: "logo",
            width: "134",
            height: "27"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default())["nav-pc"]),
        ref: subNav,
        children: menu.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return Goto(index, item.link);
            },
            className: classnames_default()((nav_index_module_default())["nav-pc-item"], index === current && (nav_index_module_default()).focus),
            children: item.name
          }, item.name);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((nav_index_module_default()).transition, count.current === 1 && (nav_index_module_default()).once, count.current > 1 && sticky && (nav_index_module_default()).active, 'for-pc')
    }), type === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob"],
      ref: menuRef,
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    }), type === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob-2"],
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    })]
  });
};

/* harmony default export */ var nav = (Nav);
;// CONCATENATED MODULE: ./src/components/product/relevance/wrapper/index.tsx









var menu1 = [{
  name: '智能硬件',
  link: '/hardware'
}, {
  name: '软件客户端',
  link: '/client'
}];
var menu2 = [{
  name: '一体化4K终端',
  link: '/hardware/fullSceneTerminal'
}, {
  name: '小鱼云镜',
  link: '/hardware/cloudMirrorSystem'
}, {
  name: '大型终端',
  link: '/hardware/flagshipTerminal'
}, {
  name: '中型终端',
  link: '/hardware/mediumTerminal'
}, {
  name: '中小型终端',
  link: '/hardware/integratedTerminal'
}, {
  name: '智能会议平板',
  link: '/hardware/meetingBoard'
}, {
  name: '电视墙服务器',
  link: '/hardware/TVwall'
}];
var menus = {
  '1': {
    name: '云视频会议',
    menu: menu1
  },
  '2': {
    name: '智能硬件',
    menu: menu2,
    type: 2
  }
};

var Wrapper = function Wrapper(_ref) {
  var title = _ref.title,
      current = _ref.current,
      children = _ref.children,
      _ref$menuIndex = _ref.menuIndex,
      menuIndex = _ref$menuIndex === void 0 ? '1' : _ref$menuIndex,
      customClass = _ref.customClass,
      pageKey = _ref.pageKey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    layoutClass: (index_module_default()).layout,
    headerClass: (index_module_default()).header,
    children: [pageKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(tdk/* default */.Z, {
      pageKey: pageKey
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: [menus[menuIndex].name, "-", title]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: classnames_default()((index_module_default()).main, customClass),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(nav, {
        menu: menus[menuIndex].menu,
        defaultIndex: current,
        type: menus[menuIndex].type || 1
      }), children]
    })]
  });
};

/* harmony default export */ var wrapper = (Wrapper);

/***/ }),

/***/ 34790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1730);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94142);
/* harmony import */ var components_transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66335);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var Index = function Index(props) {
  var _props$title, _ref, _props$data, _props$data2;

  var _props$animate = props.animate,
      animate = _props$animate === void 0 ? 'none' : _props$animate,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? 0 : _props$offset,
      _props$bgImg = props.bgImg,
      bgImg = _props$bgImg === void 0 ? '' : _props$bgImg,
      _props$mBgImg = props.mBgImg,
      mBgImg = _props$mBgImg === void 0 ? '' : _props$mBgImg;
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scheme), props.isBg && (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bg), props.className),
    style: {
      backgroundImage: "url(".concat(size.width < 768 ? mBgImg !== null && mBgImg !== void 0 ? mBgImg : bgImg : bgImg, ")")
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      delay: delay,
      offset: offset,
      animate: animate,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: 'title',
        dangerouslySetInnerHTML: {
          __html: ((_props$title = props.title) === null || _props$title === void 0 ? void 0 : _props$title.replace(/\n/g, '<br>')) || '解决方案'
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      delay: delay,
      offset: offset,
      animate: animate,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: 'mobTitle',
        dangerouslySetInnerHTML: {
          __html: (_ref = props.mTitle ? props.mTitle : props.title || '') === null || _ref === void 0 ? void 0 : _ref.replace(/\n/g, '<br>')
        }
      })
    }), props.noTitle && size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: 'scheme-wrap',
      children: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.map(function (item) {
        var _item$title;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "scheme-item",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.3,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              style: {
                backgroundImage: "url(".concat(item.mUrl, ")")
              },
              className: "img-wrapper-m"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.6,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "scheme-item-title",
              dangerouslySetInnerHTML: {
                __html: (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.replace(/\n/g, '<br>')
              }
            })
          })]
        }, item.title);
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "content grid-".concat(props.type),
      children: (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.map(function (item) {
        var _item$mUrl, _item$title2, _ref2, _item$desc;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "scheme-item",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.3,
            offset: offset,
            animate: animate,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: item.pcUrl,
              className: "img-wrapper",
              alt: ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: (_item$mUrl = item.mUrl) !== null && _item$mUrl !== void 0 ? _item$mUrl : item.pcUrl,
              className: "img-wrapper-m",
              alt: ""
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.6,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "scheme-item-content",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('scheme-item-title', 'for-pc'),
                dangerouslySetInnerHTML: {
                  __html: (_item$title2 = item.title) === null || _item$title2 === void 0 ? void 0 : _item$title2.replace(/\n/g, '<br>')
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('scheme-item-title', !item.desc && 'scheme-item-title-normal', 'for-mobile'),
                dangerouslySetInnerHTML: {
                  __html: (_ref2 = item.mTitle ? item.mTitle : item.title || '') === null || _ref2 === void 0 ? void 0 : _ref2.replace(/\n/g, '<br>')
                }
              }), item.desc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: "scheme-item-desc",
                dangerouslySetInnerHTML: {
                  __html: (_item$desc = item.desc) === null || _item$desc === void 0 ? void 0 : _item$desc.replace(/\n/g, '<br>')
                }
              })]
            })
          })]
        }, item.title);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Index);

/***/ }),

/***/ 53053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_product_scheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34790);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53784);
/* harmony import */ var components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58262);
/* harmony import */ var components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12221);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2695);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
 * 电视墙服务器
 */










var IMG_PRE = 'https://sdk-source.xylink.com/website/assets/hardware/cloud/TVwall/';
var scene = [{
  title: '政府大型会议室/应急指挥中心',
  pcUrl: IMG_PRE + 'scene-img0.jpg'
}, {
  title: '日常调度/客户参观/样板展示',
  pcUrl: IMG_PRE + 'scene-img1.jpg'
}, {
  title: '教学巡课/远程监考/沉浸式互动教学',
  pcUrl: IMG_PRE + 'scene-img2.jpg'
}, {
  title: '活动直播/电视台演播室场外连线',
  pcUrl: IMG_PRE + 'scene-img3.jpg'
}];
var bannerList = [{
  title: '电视墙服务器',
  pcUrl: 'bg0.jpg',
  mUrl: 'm/bg0.jpg',
  desc: '多方会场、监控视频、单兵和无人机等海量画面一屏统览\n实时统一调度，终端无缝融合，轻松掌握全局',
  mDesc: '多方会场、监控视频、单兵和无人机等海量画\n面一屏统览\n实时统一调度，终端无缝融合，轻松掌握全局',
  type: 4,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().firstBanner)
}, {
  title: '海量画面，一览无余',
  pcUrl: 'bg1.jpg',
  mUrl: 'm/bg1.jpg',
  desc: '支持视频会议、监控、智能眼镜、单兵终端、无人机等\n智能终端画面解码上墙',
  mDesc: '支持视频会议、监控、智能眼镜、单兵终端、\n无人机等智能终端画面解码上墙',
  type: 3,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner1)
}, {
  title: '至臻高清，自由布局',
  pcUrl: 'bg2.jpg',
  mUrl: 'm/bg2.jpg',
  desc: '高清解码能力，画面清晰\n可调整画面布局，场景预览一键自由切换',
  mDesc: '',
  type: 4
}, {
  title: '集控管理，运筹帷幄',
  pcUrl: 'bg3.jpg',
  mUrl: 'm/bg3.jpg',
  desc: '配置简单，联网即用\n通过统一界面操作，轻松进行实时监看、指挥和调度',
  mDesc: '配置简单，联网即用\n通过统一界面操作，轻松进行实时监看、指挥\n和调度',
  type: 3,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner2)
}, {
  title: '超强适应，无惧环境',
  pcUrl: 'bg4.jpg',
  mUrl: 'm/bg4.jpg',
  desc: 'SVC柔性编解码，超强网络抗丢包\n适应复杂网络环境，全面保障产品高可用',
  type: 4
}, {
  title: '灵活扩展，升级无忧',
  pcUrl: 'bg5.jpg',
  mUrl: 'm/bg5.jpg',
  desc: '支持多台堆叠，可匹配业务需求扩展系统容量',
  type: 3,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner3)
}];

var TVwall = function TVwall() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    title: "\u7535\u89C6\u5899\u670D\u52A1\u5668",
    menuIndex: "2",
    current: 6,
    customClass: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().tvWall),
    children: [bannerList.map(function (item) {
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, item), {}, {
        animate: 'fadeIn',
        delay: 0.5,
        descCenter: true,
        key: item.title,
        imageHost: IMG_PRE,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner), item.className)
      }));
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_product_scheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      animate: "fadeIn",
      delay: 0.5,
      data: scene,
      title: '应用场景',
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().scene)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().contact),
      btnType: 'newBtn'
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (TVwall);

/***/ }),

/***/ 55976:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/TVwall",
      function () {
        return __webpack_require__(53053);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"nav_border__px__LnplE","border__px-before":"nav_border__px-before__EVov9","border__px-before1":"nav_border__px-before1__2oD1e","border-children1":"nav_border-children1__g0F3X","border-children2":"nav_border-children2__DnnSf","for-mobile":"nav_for-mobile__ZciXU","for-pc":"nav_for-pc__z_KI0","nav__theme_parent":"nav_nav__theme_parent__T4U4O","logo":"nav_logo__WR8zR","show":"nav_show__4YtHP","nav-pc":"nav_nav-pc__bFsJ0","nav-pc-item":"nav_nav-pc-item__kYYYW","focus":"nav_focus__ByYUr","once":"nav_once__aksOZ","sticky":"nav_sticky__l7SSZ","transition":"nav_transition__B1wHH","active":"nav_active__1D68f","nav-mob":"nav_nav-mob__FuCYJ","nav-mob-2":"nav_nav-mob-2__6Mv2f","nav-mob-item":"nav_nav-mob-item__6k_Rb"};

/***/ }),

/***/ 89262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"wrapper_border__px__F6VvU","border__px-before":"wrapper_border__px-before__Mxpn1","border__px-before1":"wrapper_border__px-before1__EFvO6","border-children1":"wrapper_border-children1__KmKjR","border-children2":"wrapper_border-children2__7Jboy","for-mobile":"wrapper_for-mobile__2kveH","for-pc":"wrapper_for-pc__yuzrw","layout":"wrapper_layout__j4SAy","header":"wrapper_header__l9dYm"};

/***/ }),

/***/ 1730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"scheme_border__px__p2mre","border__px-before":"scheme_border__px-before__Z5zYd","border__px-before1":"scheme_border__px-before1__85u3k","border-children1":"scheme_border-children1__3YAlL","border-children2":"scheme_border-children2__7mE0p","for-mobile":"scheme_for-mobile___ycZS","for-pc":"scheme_for-pc__UIzZn","scheme":"scheme_scheme__rxdlU","bg":"scheme_bg__bVFmx"};

/***/ }),

/***/ 2695:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"TVwall_border__px__bfjGc","border__px-before":"TVwall_border__px-before__QYiwp","border__px-before1":"TVwall_border__px-before1__RgrIO","border-children1":"TVwall_border-children1__G6wq4","border-children2":"TVwall_border-children2__TLCuH","for-mobile":"TVwall_for-mobile__iXPE_","for-pc":"TVwall_for-pc__kfWB2","hardware":"TVwall_hardware__vukqt","contentWrapper":"TVwall_contentWrapper__y6HoA","header":"TVwall_header__3V3IB","bigTitle":"TVwall_bigTitle__7J5rG","arrowImg":"TVwall_arrowImg__0QI4x","horizontal":"TVwall_horizontal__6ETiJ","totalBanner":"TVwall_totalBanner__oak8E","banner":"TVwall_banner__MQYPq","title":"TVwall_title__TynDq","desc":"TVwall_desc__EFSh2","knowMore":"TVwall_knowMore__KXDxe","contact":"TVwall_contact__1cN6r","tvWall":"TVwall_tvWall__a2gJq","firstBanner":"TVwall_firstBanner__i_Nmn","banner1":"TVwall_banner1__75UZF","banner2":"TVwall_banner2__7aI3s","banner3":"TVwall_banner3__tZ_9T","scene":"TVwall_scene__4oOLO"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9243,9092,9774,2888,179], function() { return __webpack_exec__(55976); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);